export const seasonalPeriods = ['halloween', 'christmas', 'new-year', 'easter', 'valentine', 'bastille'] as const

export type SeasonalPeriod = (typeof seasonalPeriods)[number]

const toMonthDay = (date: Date): number => (date.getMonth() + 1) * 100 + date.getDate()

const isBetweenMonthDays = (date: Date, start: number, end: number): boolean => {
  const monthDay = toMonthDay(date)
  return monthDay >= start && monthDay <= end
}

export const getEasterSunday = (year: number): Date => {
  const a = year % 19
  const b = Math.floor(year / 100)
  const c = year % 100
  const d = Math.floor(b / 4)
  const e = b % 4
  const f = Math.floor((b + 8) / 25)
  const g = Math.floor((b - f + 1) / 3)
  const h = (19 * a + b - d - g + 15) % 30
  const i = Math.floor(c / 4)
  const k = c % 4
  const l = (32 + 2 * e + 2 * i - h - k) % 7
  const m = Math.floor((a + 11 * h + 22 * l) / 451)
  const month = Math.floor((h + l - 7 * m + 114) / 31)
  const day = ((h + l - 7 * m + 114) % 31) + 1

  return new Date(year, month - 1, day)
}

const isEasterPeriod = (date: Date): boolean => {
  const easterSunday = getEasterSunday(date.getFullYear())
  const start = new Date(easterSunday)
  const end = new Date(easterSunday)
  start.setDate(start.getDate() - 2)
  end.setDate(end.getDate() + 1)

  const currentDay = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
  return currentDay >= start.getTime() && currentDay <= end.getTime()
}

export const getActiveSeasonalPeriod = (date: Date = new Date()): SeasonalPeriod | null => {
  if (isBetweenMonthDays(date, 101, 107)) return 'new-year'
  if (toMonthDay(date) === 214) return 'valentine'
  if (isEasterPeriod(date)) return 'easter'
  if (toMonthDay(date) === 714) return 'bastille'
  if (isBetweenMonthDays(date, 1024, 1101)) return 'halloween'
  if (isBetweenMonthDays(date, 1215, 1226)) return 'christmas'

  return null
}

export const getActiveSeasonalPeriodForUser = (costHistory: boolean, date: Date = new Date()): SeasonalPeriod | null =>
  costHistory ? getActiveSeasonalPeriod(date) : null
